import { useSelector } from 'react-redux';

import StyledWrapper from './style';
import { formatDateWithTime } from '../../utils/dateUtils';

const LastEdited = ({ data, editingRow }) => {
	const username = useSelector((state) => state?.login?.user?.userName);

	return (
		<StyledWrapper.LastEdited data-testid={'applicationprocess-lastedited'}>
			{data?.firstName &&
				`Last edited by: ${data?.firstName} ${data?.lastName}, ${
					data?.time && formatDateWithTime(data?.time)
				}`}
			{editingRow && ` / You (${username}) editing now.`}
		</StyledWrapper.LastEdited>
	);
};

export default LastEdited;
